import { render, staticRenderFns } from "./DialogApproval.vue?vue&type=template&id=2668c082&scoped=true"
import script from "./DialogApproval.js?vue&type=script&lang=js&external"
export * from "./DialogApproval.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668c082",
  null
  
)

export default component.exports